import { apiService, createRequestHeadersConfig } from 'shared/api'
import { isNilOrEmpty } from 'shared/utils/ramda'

import { SingleSaleOrderResponse } from '../../types'

import { EditSaleOrderCartResponse } from './types'

const api = apiService()

interface EditSaleOrderPayload {
  saleOrderId: string
  token?: string
}

interface FinishEditSaleOrderPayload extends EditSaleOrderPayload {
  cartId: string
  paymentMethodId: string
  blikCode?: string
}

export const beginEditSaleOrder = async ({
  saleOrderId,
  token
}: EditSaleOrderPayload): Promise<EditSaleOrderCartResponse> => {
  const result: EditSaleOrderCartResponse = await api.patch(
    `/sale-orders/${saleOrderId}/edit-begin`,
    {},
    createRequestHeadersConfig(token)
  )

  return result
}

export const cancelEditSaleOrder = ({
  saleOrderId,
  token
}: EditSaleOrderPayload) =>
  api.delete(
    `/sale-orders/${saleOrderId}/edit-cancel`,
    createRequestHeadersConfig(token)
  )

export const finishEditSaleOrder = async ({
  saleOrderId,
  cartId,
  paymentMethodId,
  blikCode,
  token
}: FinishEditSaleOrderPayload): Promise<SingleSaleOrderResponse> => {
  const payload = isNilOrEmpty(blikCode)
    ? { paymentMethodId }
    : { paymentMethodId, blik_code: blikCode }
  const result: SingleSaleOrderResponse = await api.post(
    `/sale-orders/${saleOrderId}/edit-finish/${cartId}`,
    payload,
    createRequestHeadersConfig(token)
  )

  return result
}
